module.exports = __webpack_public_path__ + "./images/bf6b1abf8e7b39c3dd70a3d720161009.jpg";